var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveTimeTracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 6,
    fill: "#88D4FF",
    stroke: "#88D4FF",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_151_127384",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_151_127384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4001 26.2665L26.2667 24.3998L21.3334 19.4665V13.3332H18.6667V20.5332L24.4001 26.2665ZM20.0001 33.3332C18.1556 33.3332 16.4223 32.9832 14.8001 32.2832C13.1779 31.5832 11.7667 30.6332 10.5667 29.4332C9.36675 28.2332 8.41675 26.8221 7.71675 25.1998C7.01675 23.5776 6.66675 21.8443 6.66675 19.9998C6.66675 18.1554 7.01675 16.4221 7.71675 14.7998C8.41675 13.1776 9.36675 11.7665 10.5667 10.5665C11.7667 9.3665 13.1779 8.4165 14.8001 7.7165C16.4223 7.0165 18.1556 6.6665 20.0001 6.6665C21.8445 6.6665 23.5779 7.0165 25.2001 7.7165C26.8223 8.4165 28.2334 9.3665 29.4334 10.5665C30.6334 11.7665 31.5834 13.1776 32.2834 14.7998C32.9834 16.4221 33.3334 18.1554 33.3334 19.9998C33.3334 21.8443 32.9834 23.5776 32.2834 25.1998C31.5834 26.8221 30.6334 28.2332 29.4334 29.4332C28.2334 30.6332 26.8223 31.5832 25.2001 32.2832C23.5779 32.9832 21.8445 33.3332 20.0001 33.3332ZM20.0001 30.6665C22.9556 30.6665 25.4723 29.6276 27.5501 27.5498C29.6279 25.4721 30.6667 22.9554 30.6667 19.9998C30.6667 17.0443 29.6279 14.5276 27.5501 12.4498C25.4723 10.3721 22.9556 9.33317 20.0001 9.33317C17.0445 9.33317 14.5279 10.3721 12.4501 12.4498C10.3723 14.5276 9.33341 17.0443 9.33341 19.9998C9.33341 22.9554 10.3723 25.4721 12.4501 27.5498C14.5279 29.6276 17.0445 30.6665 20.0001 30.6665Z",
    fill: "#002E40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveTimeTracking);
export default __webpack_public_path__ + "static/media/ActiveTimeTracking.3e6f1b2ed4ad8e5911bba51e7033bbac.svg";
export { ForwardRef as ReactComponent };